import styled from "styled-components";

import { colorFromTheme } from "../../utils/color";
import ContainerButton from "../buttons/ContainerButton";

const Pill = styled.span`
  display: inline-block;
  padding: 0.5rem 0.7rem;
  line-height: normal;
  margin: 0.2rem;
  border-radius: 0.25rem;
  background-color: ${colorFromTheme("surface3")};
  border: 1px solid ${colorFromTheme("surface6")};
  color: ${colorFromTheme("text")};
`;

export const PillButton = styled(ContainerButton)`
  display: inline-block;
  padding: 0.5rem 0.7rem;
  line-height: normal;
  margin: 0.2rem;
  border-radius: 0.25rem;
  background-color: ${colorFromTheme("surface3")};
  border: 1px solid ${colorFromTheme("surface6")};
  color: ${colorFromTheme("text")};
`;

export default Pill;
